export const API_URL = "https://api.notaleksa.com/api";
// export const API_URL = "http://192.168.0.36:8000/api";

export const SOCKET_URL = "https://socket.selonadlanu.rs/";